import { deserialize, serializable } from 'serializr';

export class JiraSearchIssueFieldStatusModel {
  @serializable
  public description: string;
  @serializable
  public iconUrl: string;
  @serializable
  public id: string;
  @serializable
  public name: string;
  @serializable
  public self: string;

  deserialize(input: any): this {
    return Object.assign(
      this,
      deserialize(JiraSearchIssueFieldStatusModel, input),
    );
  }
}
